import { render } from "./RevueRecherche.vue?vue&type=template&id=05f82154&scoped=true"
import script from "./RevueRecherche.vue?vue&type=script&lang=js"
export * from "./RevueRecherche.vue?vue&type=script&lang=js"

import "./RevueRecherche.vue?vue&type=style&index=0&id=05f82154&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f82154"]])

export default __exports__